import { atom } from 'jotai';
import { ClickPosition } from '~/utils/click-position';

export const $CurrentPosition = atom<ClickPosition | ''>('');
